import PepBoysLogo from "../assets/images/pepboys_logo.svg"
import FirestoneLogo from "../assets/images/firestone.svg"
import JiffyLubeLogo from "../assets/images/jiffylube.svg"
import DiscountTireLogo from "../assets/images/discount-tire.svg"
import ValvolineLogo from "../assets/images/valvoline.svg"
import MrTireLogo from "../assets/images/mr-tire.svg"
import MidasLogo from "../assets/images/midas.svg"
import TirechoiceLogo from "../assets/images/tire-choice.svg"
import AmericanTireLogo from "../assets/images/american-tire.svg"
import TirePlusLogo from "../assets/images/tires-plus.svg"
import MonroLogo from "../assets/images/monro.svg"
import StallantisLogo from "../assets/images/stell.svg"
import CarXlogo from "../assets/images/CarX.svg"
import GoodYearLogo from "../assets/images/googyear.svg"
import Valvoline from "../assets/images/valvoline.svg"

export const BRAND_LOGO = [
  PepBoysLogo,
  FirestoneLogo,
  JiffyLubeLogo,
  DiscountTireLogo,
  ValvolineLogo,
  MrTireLogo,
  MidasLogo,
  TirechoiceLogo,
  AmericanTireLogo,
  TirePlusLogo,
  MonroLogo,
  StallantisLogo,
  Valvoline,
  CarXlogo,
  GoodYearLogo
]

